<svelte:options runes={false} />

<script>
  import { minorToMoney } from '../../api/invoices';
  import StatRow from './StatRow.svelte';

  export let currency;
  export let quote;
  export let feeQuoteAvailable;
</script>

<!-- `.totals` draws each row as its own bordered card, which is right on the payer
     surface where there are two or three of them at reading width. Here there are
     five, in a column that is now the wide half of the desk, and they read as five
     boxes rather than as one quote. `.ledger-rows` keeps the same rows as ruled
     lines with the grand total emphasised. -->
<section class="totals ledger-rows" aria-label="Expected payer quote">
  <h3>Expected payer quote</h3>
  <StatRow label="Reported labor" value={minorToMoney(quote.baseMinor, currency)} />
  <StatRow label="Fixed costs" value={minorToMoney(quote.fixedCostsMinor, currency)} />
  <StatRow label="Tax" value={minorToMoney(quote.taxMinor, currency)} />
  <StatRow
    label="Estimated payer processor fee"
    value={feeQuoteAvailable ? minorToMoney(quote.quotedPayerProcessorFeeMinor, currency) : 'unavailable'}
  />
  <StatRow
    grand
    label={feeQuoteAvailable ? 'Suggested charge total' : 'Suggested total before processor fee'}
    value={minorToMoney(quote.chargeTotalMinor, currency)}
  />
  <p class="quiet">Uses all reported items, the invoice asking rate, and no payer-added contribution.</p>
  {#if !feeQuoteAvailable}
    <p class="quiet">No matching estimate is configured; payment remains available without a payer processor-fee contribution.</p>
  {/if}
</section>
